<script setup>
import { inject } from 'vue'
import { useDebounceFn } from '@vueuse/core'

const evaluation = defineModel('evaluation', { type: String })
const customDefinition = defineModel('customDefinition', { type: String })

const props = defineProps({
  action: {
    type: Object,
    default: undefined,
  },
  version: {
    type: Number,
    default: 0,
  },
})

const evaluationOptions = [
  {
    value: 'implemented',
    label: 'Bereits umgesetzt',
  },
  {
    value: 'unrequired',
    label: 'Können / werden wir nicht umsetzen',
  },
  {
    value: 'possible',
    label: 'Können wir umsetzen',
  },
  {
    value: 'customize',
    label: 'Können wir umsetzen mit Anpassungen',
  },
]

const onSaveEvaluation = inject('onSaveEvaluation')

const saveEvaluation = function () {
  onSaveEvaluation({
    id: props.action.id,
    value: evaluation.value,
    customDefinition: customDefinition.value,
    version: props.version,
  })
}

const debouncedSave = useDebounceFn(saveEvaluation, 1000)

const handleInput = () => {
  debouncedSave()
}

const handleBlur = () => {
  saveEvaluation()
}
</script>

<template>
  <div class="AssessmentActionEvaluation">
    <div class="AssessmentActionEvaluation-options">
      <div
        v-for="option in evaluationOptions"
        :key="props.action.id + '-' + option.value"
        class="AssessmentActionEvaluation-option"
      >
        <input
          :id="'action-' + props.action.id + '-' + option.value"
          v-model="evaluation"
          type="radio"
          :name="'action-' + props.action.id"
          :value="option.value"
          class="AssessmentActionEvaluation-optionInput"
          @change="saveEvaluation"
        />
        <label
          :for="'action-' + props.action.id + '-' + option.value"
          class="AssessmentActionEvaluation-optionLabel"
        >
          {{ option.label }}
        </label>
      </div>
    </div>
    <div
      v-if="evaluation == 'customize'"
      class="AssessmentActionEvaluation-textarea"
    >
      <label
        class="AssessmentActionEvaluation-textareaLabel visually-hidden"
        :for="'custom-action-' + props.action.id"
        >Angepasste Maßnahme:</label
      >
      <textarea
        :id="'custom-action-' + props.action.id"
        v-model="customDefinition"
        placeholder="Bitte tragen Sie hier eine an Ihre Bedürfnisse angepasste Version der Maßnahme ein…"
        class="AssessmentActionEvaluation-textareaInput"
        :name="'customaction-' + props.action.id"
        @input="handleInput"
        @blur="handleBlur"
      ></textarea>
    </div>
  </div>
</template>
